import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import CustomersPowerSelect from '../../customers/customers-power-select.jsx';

export default class SystemSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      isLoading: !props.systemSettings,
      momentFormatString: 'ddd Do MMM YYYY',
      momentFormatStringCSV: 'ddd Do MMM YYYY - HHmmss',
      systemSettings: props.systemSettings || null,
      url: props.url ||
        '/api/v1/portal/portal-admin/system-settings',
      saveUrl: props.saveUrl ||
        '/api/v1/portal/portal-admin/system-settings/company-customers',
      acvCustomerId: null,
      bvlCustomerId: null,
      cndCustomerId: null,
      g4CustomerId: null,
      sccdCustomerId: null,
    };
  }

  getSystemSettingsForCompany() {
    return fetch(this.state.url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer ' + window.api_token
        , "Accept": 'application/json'
      },
    }).then((responseText) => {
      let response = responseText.json();
      response.then((response) => {
        this.setState({
          systemSettings: response,
          isLoading: false
        })
      });
    });
  }

  handleCustomerSelection(e, companyTLA) {
    switch(companyTLA) {
      case 'CVM':
        this.setState({
          cvmCustomerId: e.id
        });
        break;
    }
  }

  saveCustomer(e, companyTLA) {
   let companyCustomerData = {};

    switch(companyTLA) {
      case 'CVM':
        companyCustomerData.cvmCustomerId = this.state.cvmCustomerId;
        break;
    }

    return fetch(this.state.saveUrl, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer ' + window.api_token
        , "Accept": 'application/json'
      },
      body: JSON.stringify(companyCustomerData)
    }).then((responseText) => {
      let response = responseText.json();
      response.then((response) => {
        console.log(response);
      });
    });
  }

  componentDidMount() {
    if (this.state.isLoading) {
      this.getSystemSettingsForCompany();
    }
    let that = this;
    Echo.channel('system-settings')
      .listen('SystemSettingsChanged',
        (e) => {
        that.getSystemSettingsForCompany();
      });
  }


  componentWillReceiveProps(nextProps) {
    this.setState({
      customers: nextProps.customers
    });
  }

  render() {
    return (
          (this.state.isLoading) ?
            (<span className="add-loading-text">
          <i className="fa fa-spinner fa-pulse"></i></span>) :
          <div>
            <div className="row">
              <div className="col-md-12 col-sm-12">
                <h2>System Settings</h2>
              </div>
            </div>

            <div className="row">
              <div className="col-md-4">
              </div>
              <div className="col-md-4 col-sm-12">
                <h3>
                  Company Customers (for Subcontracting Invoicing)
                </h3>

                <div>
                  <label>CVM</label>
                  <CustomersPowerSelect
                    selectedOption={this.state.systemSettings.cvm_customer_id}
                    handleCustomerSelection={
                      (e) => this.handleCustomerSelection(e,'CVM')
                    }
                  />
                  <p
                      className="text-right"
                    >
                      <button
                        className="btn btn-sm btn-success"
                        onClick={(e) => this.saveCustomer(e,'CVM')}
                      >
                        <i className="fa fa-save"></i> save
                      </button>
                    </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
            </div>
        </div>
    );
  }
}
if (document.getElementById(
  'react-component-g4-logistics-portal-portal-admin-system-settings')) {
  ReactDOM.render(
    <SystemSettings
      message_if_none = 'No Customers found. Add one to see it here.'
    />,
    document.getElementById(
      'react-component-g4-logistics-portal-portal-admin-system-settings'
    )
  );
}